export class SettingShipmentRules {
  public ID: number;
  public weight: string;
  public dimension: string;
  public days: string;
  public shipmentMethodId: number;
  public shipmentMethodTitle: string;
}



// WEBPACK FOOTER //
// ./src/app/models/SettingShipmentRules/SettingShipmentRules-model.ts